import { Component, OnInit, Input } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { SpeechRecArtifact } from '../data/student-artifact';

@Component({
  selector: 'app-speech-rec-artifact',
  templateUrl: './speech-rec-artifact.component.html',
  styleUrls: ['./speech-rec-artifact.component.css']
})
export class SpeechRecArtifactComponent extends BaseComponent implements OnInit {

  @Input() studentId: number;
  @Input() artifactId: number;
  artifact: SpeechRecArtifact;
  isLoading: boolean = true;

  ngOnInit() {
    this.dataService.getArtifact(this.studentId, this.artifactId).subscribe(a => {
      if(!a) return;
      var decodedData = window.atob(a.Data);
      if (a.ArtifactType === "speech_rec") {
        this.artifact = SpeechRecArtifact.ParseSpeechRecArtifact(decodedData);
        decodedData = this.artifact.Attempts[0].Recording;
      }
      else
      {
        console.error("Expected a Speech Rec artifact, but was a different artifact type.");
      }

      this.isLoading = false;
    });
  }

  playArtifactAudio(){}


  // getArtifactBinary(result: Artifact) {


  //   var binary = Artifact.convertEncodedDataToBinary(data);

  //   if (result.ArtifactType === "colored_page") {
  //     var unsafeURL = URL.createObjectURL(new Blob([binary], { type: 'audio/png' }));
  //   } else {
  //     var unsafeURL = URL.createObjectURL(new Blob([binary], { type: 'audio/mp3' }));
  //   }
  //   return this.sanitizer.bypassSecurityTrustResourceUrl(unsafeURL);
  // }

}
